// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../fe-workerportal/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ellipsis[data-v-228a6b00]{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;vertical-align:middle}.messageIcon[data-v-228a6b00]{font-size:1.2rem}", ""]);
// Exports
module.exports = exports;
